(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/components/tur/payfooter/assets/javascripts/constants.js');
"use strict";


svs.tur.payfooter.constants = {
  PAYFOOTER_LEGAL_INFO: '* Mottagaren måste ha fyllt 18 år och erhåller den lott och vinstplan som gäller vid tillfället för inlösen.'
};

 })(window);